import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/index.scss";
import App from "./App.tsx";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

// import reportWebVitals from './reportWebVitals';

// Data router (ikke <BrowserRouter>), så sider kan stoppe navigering med
// useBlocker, f.eks. «Forkaste endringene?» i kampanjeskjemaet. Alle ruter
// ligger fortsatt i <Routes> i App.
const router = createBrowserRouter([{ path: "*", element: <App /> }]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);

// reportWebVitals();
